import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-cambridge-design-colossus.eu.auth0.com"
      clientId="kHsyI0kBq0IzDQHCj4vlT966OF69a4wU"
      authorizationParams={{
        redirect_uri: window.location.origin,
        cacheLocation: "localstorage",
        audience: "https://backend.dev.aeolus.cambridge-design.net",
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
